// Shared AI Agents catalog for use across pages (Agents list, Workflow palette, etc.)

export interface AIAgent {
  id: string;
  name: string;
  type: string;
  description: string;
  category: 'document' | 'support' | 'compliance' | 'reports' | 'analytics' | 'customer' | 'risk' | 'fraud' | 'claims' | 'underwriting';
  icon: string;
  color: string; // tailwind gradient classes, optional for UI
}

export const AI_AGENTS_CATALOG: AIAgent[] = [
  { id: 'agent-001', name: 'OCR Agent', type: 'Document Processing', description: 'Extracts text from images or PDFs', category: 'document', icon: '👁️', color: 'from-blue-500 to-blue-600' },
  { id: 'agent-003', name: 'Compliance Audit Agent', type: 'Compliance AI', description: 'Automated regulatory compliance monitoring', category: 'compliance', icon: '🛡️', color: 'from-amber-500 to-amber-600' },
  { id: 'agent-004', name: 'Reporting Agent', type: 'Reports AI', description: 'Automated report generation and visualization', category: 'reports', icon: '📊', color: 'from-indigo-500 to-indigo-600' },
  { id: 'agent-006', name: 'AI Blogging Agent', type: 'Content AI', description: 'Content generation and optimization', category: 'analytics', icon: '✍️', color: 'from-purple-500 to-purple-600' },
  { id: 'agent-007', name: 'Txt-Image Agent', type: 'Multimodal AI', description: 'Text-to-image generation', category: 'analytics', icon: '🎨', color: 'from-pink-500 to-pink-600' },
  { id: 'agent-008', name: 'Content Audit Agent', type: 'Content AI', description: 'Content analysis and optimization', category: 'analytics', icon: '🔍', color: 'from-orange-500 to-orange-600' },
  { id: 'agent-009', name: 'AI Translator', type: 'Language AI', description: 'Real-time multilingual translation', category: 'analytics', icon: '🌐', color: 'from-green-500 to-green-600' },
  { id: 'agent-002', name: 'Customer Support Agent', type: 'Support AI', description: 'Automated customer service with NLP', category: 'support', icon: '💬', color: 'from-teal-500 to-teal-600' },
];


